import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCalendarAlert = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.25 17.25H2.25C1.85218 17.25 1.47064 17.092 1.18934 16.8107C0.908035 16.5294 0.75 16.1478 0.75 15.75V3.75C0.75 3.35218 0.908035 2.97064 1.18934 2.68934C1.47064 2.40804 1.85218 2.25 2.25 2.25H15.75C16.1478 2.25 16.5294 2.40804 16.8107 2.68934C17.092 2.97064 17.25 3.35218 17.25 3.75V8.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 6.75H17.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 3.75V0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 3.75V0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 19.5C17.1758 19.5 17.1033 19.522 17.0417 19.5632C16.98 19.6044 16.9319 19.663 16.9035 19.7315C16.8752 19.8 16.8677 19.8754 16.8822 19.9482C16.8967 20.0209 16.9324 20.0877 16.9848 20.1402C17.0373 20.1926 17.1041 20.2283 17.1768 20.2428C17.2496 20.2573 17.325 20.2498 17.3935 20.2215C17.462 20.1931 17.5206 20.145 17.5618 20.0833C17.603 20.0217 17.625 19.9492 17.625 19.875C17.625 19.7755 17.5855 19.6802 17.5152 19.6098C17.4448 19.5395 17.3495 19.5 17.25 19.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 17.25V15"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.063 20.683C23.1981 20.9535 23.2619 21.254 23.2483 21.5561C23.2346 21.8581 23.144 22.1517 22.985 22.4089C22.826 22.666 22.6039 22.8783 22.3398 23.0255C22.0757 23.1728 21.7784 23.25 21.476 23.25H13.024C12.7216 23.25 12.4243 23.1728 12.1602 23.0255C11.8961 22.8783 11.674 22.666 11.515 22.4089C11.356 22.1517 11.2653 21.8581 11.2517 21.5561C11.238 21.254 11.3018 20.9535 11.437 20.683L15.663 12.231C15.8103 11.9362 16.0368 11.6882 16.3171 11.5149C16.5974 11.3416 16.9204 11.2498 17.25 11.2498C17.5795 11.2498 17.9026 11.3416 18.1829 11.5149C18.4632 11.6882 18.6897 11.9362 18.837 12.231L23.063 20.683Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCalendarAlert.displayName = 'SvgCalendarAlert';
export default SvgCalendarAlert;
